{
  "carrierLabel": "Firma przewozowa",
  "searchPlaceholder": "Szukaj według nazwy",
  "selectAsCarrier": "Wybierz \"{name}\" jako przewoźnika",
  "typeToSearch": "Wpisz, aby wyszukać firmę"
}
